import { defineComponent, ref, computed, watch, onMounted } from "vue";
import parseInt from "./component-library257.mjs";
import padStart from "./component-library258.mjs";
import InputWrapper from "./component-library19.mjs";
import { useLabeledInput } from "./component-library256.mjs";
import SelectInput from "./component-library26.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "date-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    inlineLabel: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { default: void 0 },
    minYear: { default: 1900 },
    maxYear: { default: (/* @__PURE__ */ new Date()).getFullYear() }
  },
  emits: ["input", "focus"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const { inputWrapperProps, inputId, onInput, focus } = useLabeledInput(props, emits);
    function buildOption(value) {
      const label = padStart(value.toString(), 2, "0");
      return { label, value };
    }
    const dateDay = ref(null);
    const dateMonth = ref(null);
    const dateYear = ref(null);
    const getDateFromString = (value) => {
      if (!value) {
        dateDay.value = null;
        dateMonth.value = null;
        dateYear.value = null;
        return;
      }
      const [year, month, day] = value.split("-").map(parseInt);
      dateDay.value = day;
      dateMonth.value = month;
      dateYear.value = year;
    };
    const DAYS = Array.from({ length: 31 }, (_, i) => buildOption(i + 1));
    const MONTHS = Array.from({ length: 12 }, (_, i) => buildOption(i + 1));
    const options = ref({
      day: DAYS,
      month: MONTHS
    });
    const showInlineLabel = computed(() => !props.inlineLabel && !props.large && !props.medium);
    const dateString = computed(() => {
      if (!dateDay.value || !dateMonth.value || !dateYear.value)
        return null;
      const day = padStart(dateDay.value.toString(), 2, "0");
      const month = padStart(dateMonth.value.toString(), 2, "0");
      return `${dateYear.value}-${month}-${day}`;
    });
    const availableYears = computed(() => {
      const yearData = [];
      for (let count = props.maxYear; count >= props.minYear; count -= 1) {
        yearData.push(count.toString());
      }
      return yearData;
    });
    watch(
      () => props.value,
      (val) => {
        getDateFromString(val);
      }
    );
    onMounted(() => {
      getDateFromString(props.value);
    });
    const onSelect = () => {
      emits("input", dateString.value);
    };
    expose({
      focus,
      onSelect,
      onInput,
      availableYears,
      dateDay,
      dateMonth,
      dateYear,
      dateString
    });
    return { __sfc: true, props, emits, inputWrapperProps, inputId, onInput, focus, buildOption, dateDay, dateMonth, dateYear, getDateFromString, DAYS, MONTHS, options, showInlineLabel, dateString, availableYears, onSelect, InputWrapper, SelectInput };
  }
});
export {
  _sfc_main as default
};
